export { default } from './LowestRatesPropertiesContainerMobile';
